import { Component, OnInit, Inject } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { filter } from "rxjs/operator/filter";
import { HttpServiceHelper } from "../HttpServiceHelper";

@Component({
  selector: "app-vertical-department-pop-up",
  templateUrl: "./vertical-department-pop-up.component.html",
  styleUrls: ["./vertical-department-pop-up.component.css"],
})
export class VerticalDepartmentPopUpComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<VerticalDepartmentPopUpComponent>,
    public httpServ: HttpServiceHelper,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}
  selectedVertical: string = "";
  selectedunit: string = "";
  selectedDepartment: string = "";
  verticalData: any[];
  unitOptions: any[];
  verticalOptions: any[];
  departmentOptions: any[];

  ngOnInit() {
    this.httpServ.getVerticalDepartments().subscribe((d) => {
      this.verticalData = d.payload;
      this.setUintData();
    });
  }

  setUintData() {
    const uniqueUnits = new Set<string>();
    this.verticalData.forEach((item) => uniqueUnits.add(item.unit));
    this.unitOptions = Array.from(uniqueUnits);
    if (this.data.unitData) {
      this.selectedunit = this.data.unitData.unit;
      this.selectedVertical = this.data.unitData.vertical;
      this.selectedDepartment = this.data.unitData.department;
      this.onVerticalChange(undefined, "");
    }
  }
  onVerticalChange(e: any, type: any) {
    if (type == "unit") {
      this.selectedVertical = "";
      this.selectedDepartment = "";
    } else if (type == "vert") {
      this.selectedDepartment = "";
    }
    if (this.selectedunit) {
      this.verticalOptions = this.verticalData.filter(
        (u) => u.unit == this.selectedunit
      );
    }
    if (this.selectedVertical) {
      let filterData = this.verticalData.filter(
        (d) =>
          d.unit == this.selectedunit && d.vertical == this.selectedVertical
      );
      this.departmentOptions =
        filterData.length > 0 ? filterData[0].department : [];
    }
  }
  onNoClick(): void {
    if (this.selectedunit && this.selectedVertical && this.selectedDepartment) {
      let data = {
        unit: this.selectedunit,
        vertical: this.selectedVertical,
        department: this.selectedDepartment,
      };
      this.dialogRef.close(data);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/vertical-department-pop-up/vertical-department-pop-up.component.ts